module.exports = __webpack_public_path__ + "supplier/img/placeholder1.16370aa2.png";